document.addEventListener('DOMContentLoaded', function () {
    let blog_swiper = new Swiper('.blog_slide_container .slide_blog_swiper', {
        loop: true,
        pagination: {
            el: '.blog_slide_container .swiper-pagination-blog',
            clickable: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            500: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            769: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
        },
    });
});